import {
    TableCell,
    tableCellClasses,
    TableRow,
} from "@mui/material";
import styled, { css, keyframes } from "styled-components";
import { color } from "../../../../../../shared/styles";
import { CELL_WIDTH } from "../../../../../../shared/components/CustomTable/Styled";

const fadeIn = keyframes`
    from {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
    to {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
`;

const fadeOut = keyframes`
    from {
        opacity: 1;
        transform: translate(-50%, -50%);
    }
    to {
        opacity: 0;
        transform: translate(-50%, -60%);
    }
`;

export const ModalWrapper = styled.div<{ isOpen: boolean }>`
    padding: 24px;
    max-width: 80vw;
    width: 70vw;
    min-width: 500px;
    height: 80vh;
    max-height: 80vh;
    border-radius: 8px;
    background-color: white;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 24px;
    font-family: Noto Sans;
    overflow: visible;
    opacity: ${({ isOpen }) => (isOpen ? 1 : 0)};
    animation: ${({ isOpen }) =>
        isOpen
            ? css`
                  ${fadeIn} 0.3s ease-out forwards
              `
            : css`
                  ${fadeOut} 0.3s ease-out forwards
              `};
`;

export const Expandable = styled.div`
    display: flex;
    flex-direction: column;
    gap: 20px;
    flex: 1;
    min-height: 0;
    overflow: visible;
`;

export const TableScrollArea = styled.div`
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding-right: 8px;

    /* Customize scrollbar */
    &::-webkit-scrollbar {
        width: 8px;
    }
    &::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
        background: #888;
        border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
`;

export const TitleWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

export const InfoText = styled.div`
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`;

export const TitleText = styled.div`
    font-size: 22px;
    font-style: normal;
    font-weight: 700;
    line-height: 28px;
`;

export const SummaryTableRow = styled(TableRow)`
    background-color: ${color.secondary.LIGHT_GREY};
    position: sticky;
    z-index: 10;
    bottom: 0;
`;

export const SummaryTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.body}`]: {
        color: "#0D0C0C",
        fontSize: "14px",
        fontWeight: "700",
        lineHeight: "42px",
        wordWrap: "break-word",
        padding: "8px 8px 8px 8px",
        width: CELL_WIDTH,
        minWidth: CELL_WIDTH,
        fontFamily: "Noto Sans",
        whiteSpace: "nowrap",
    },
}));

export const ButtonRow = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    gap: 24px;
    flex-shrink: 0;
`;
